import { render } from "./BoxNovaApp.vue?vue&type=template&id=129f58b2"
import script from "./BoxNovaApp.vue?vue&type=script&lang=js"
export * from "./BoxNovaApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__